export const SHEET_WIDTH = 816;
export const PAGE_HEIGHT = 1056;
export const CONTENT_WIDTH = 720;

export const LANDSCAPE_SHEET_WIDTH = 1056;
export const LANDSCAPE_PAGE_HEIGHT = 816;
export const LANDSCAPE_CONTENT_WIDTH = 960;

export const sheetMetrics = (landscape) =>
  landscape
    ? {
        sheetWidth: LANDSCAPE_SHEET_WIDTH,
        pageHeight: LANDSCAPE_PAGE_HEIGHT,
        contentWidth: LANDSCAPE_CONTENT_WIDTH
      }
    : { sheetWidth: SHEET_WIDTH, pageHeight: PAGE_HEIGHT, contentWidth: CONTENT_WIDTH };

export const percentOf = (value, base) => `${((value / base) * 100).toFixed(4)}%`;

export const contentPercent = (value, base = CONTENT_WIDTH) => percentOf(value, base);

export const DOC_TEXT = {
  practiceName: 'text-base font-700 leading-5 text-neutral-900',
  headerBody: 'text-[11px] font-400 leading-4 text-neutral-700',
  docTitle: 'text-xl font-700 leading-[26px] text-primary-600',
  docKicker: 'text-[11px] font-700 uppercase leading-4 tracking-[0.08em] text-primary-600',
  sectionHead: 'text-[11px] font-700 uppercase leading-4 tracking-[0.08em] text-primary-700',
  microLabel: 'text-xxs font-700 uppercase leading-[14px] tracking-[0.06em] text-neutral-500',
  fieldValue: 'text-[13px] font-700 leading-[19px] text-neutral-900',
  body: 'text-[13px] leading-[19px] text-neutral-900',
  bodyMuted: 'text-xs leading-[18px] text-neutral-700',
  meta: 'text-[11px] leading-4 text-neutral-700',
  cardLine: 'text-[13px] leading-[19px] text-neutral-900',
  cardSub: 'text-[11px] leading-4 text-neutral-700',
  cardAmount: 'text-[26px] font-700 leading-8 tabular-nums text-neutral-900',
  columnLabel: 'text-xxs font-700 uppercase leading-[14px] tracking-[0.06em] text-neutral-500',
  groupLabel: 'text-xxs font-700 uppercase leading-[14px] tracking-[0.06em] text-neutral-700',
  groupNote: 'text-xxs leading-[14px] text-neutral-500',
  cell: 'text-xs leading-4 text-neutral-900',
  cellSub: 'text-xxs leading-[14px] text-neutral-500',
  cellTint: 'text-[11px] leading-4 text-neutral-700',
  totalsCell: 'text-xs font-800 leading-4 text-neutral-900',
  bannerTitle: 'text-xs font-700 leading-4 text-neutral-900',
  bannerSubtitle: 'text-xxs leading-[14px] text-neutral-500',
  legend: 'text-xxs leading-[14px] text-neutral-500',
  summaryLabel: 'text-xs leading-4 text-neutral-700',
  summaryValue: 'text-xs leading-4 tabular-nums text-neutral-900',
  summaryTotal: 'text-[13px] font-700 leading-[19px] text-neutral-900',
  summaryRow: 'text-[13px] leading-[19px] text-neutral-900',
  summarySub: 'text-[11px] leading-4 text-neutral-500',
  summaryGrand: 'text-[15px] font-800 leading-5 text-neutral-900',
  note: 'text-[11px] leading-4 text-neutral-700',
  closing: 'text-[11px] italic leading-4 text-neutral-700',
  footer: 'text-xxs leading-[14px] text-neutral-500',
  footerPage: 'text-xxs font-700 leading-[14px] text-neutral-700'
};

export const DOC_GAPS = {
  headerRule: 'mt-[18px]',
  section: 'mt-4',
  sectionTight: 'mt-[14px]',
  sectionWide: 'mt-6',
  heading: 'mb-2',
  headingWide: 'mb-3',
  totals: 'mt-2',
  closing: 'mt-3',
  footer: 'mt-5'
};

export const SUMMARY_WIDTH_CLASS = 'w-[280px]';

export const withSlotWidths = (columns, slots = {}, base = CONTENT_WIDTH) => {
  const fixedTotal = columns.reduce((sum, column) => sum + (slots[column.key] || 0), 0);

  return columns.map((column) => ({
    ...column,
    width: slots[column.key]
      ? contentPercent(slots[column.key], base)
      : contentPercent(base - fixedTotal, base)
  }));
};
